import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/static/justine_logo.svg"
      {...props}
    />
  );
}

export default Logo;
